import React from 'react'

import { Text } from '@hhgtech/hhg-components/mantine'
import { AspectRatio, Box, BoxProps } from '@mantine/core'

import useStyles from './index.styles'

export type CarePathOptionProps = {
  label: string
  icon: string
  groupId: string
  bgColor: string
  termId: string
} & BoxProps

const CarePathOption = ({
  label,
  icon,
  className,
  classNames,
  styles,
  ...boxProps
}: CarePathOptionProps) => {
  const { classes, cx } = useStyles(undefined, {
    name: 'CarePathSelection__Option',
    styles,
    classNames,
  })
  return (
    <Box className={cx(className, classes.root)} {...boxProps}>
      <Box className={classes.wrapper}>
        <AspectRatio
          className={classes.thumbnail}
          ratio={240 / 160}
          w="100%"
          variant=""
        >
          <img
            src={`${icon}?w=300&q=90`}
            style={{ borderRadius: 'inherit' }}
            alt=""
            loading="lazy"
          />
        </AspectRatio>
        <Text className={classes.heading} size="s3" weight="semiBold">
          {label}
        </Text>
      </Box>
    </Box>
  )
}

export { CarePathOption }
